import axios from 'axios';
import { Message } from 'element-ui'


export function uploadFile(file){
  var promise = new Promise((resolve,reject) => {
    let formData = new FormData();
    formData.append('file', file);
    let fileUrl =  '';
    if(!process.env.VUE_APP_API){
      fileUrl = location.origin +  '/crm/file/upload';
    }else {
      fileUrl = process.env.VUE_APP_API +  'crm/file/upload';
    }
    // let fileUrl =  process.env.VUE_APP_API + 'crm/file/upload';
    if(window.location.origin.indexOf('https') > -1 && fileUrl.indexOf('https') == -1){
      fileUrl = fileUrl.replace('http','https');
    }
    axios({
      url: fileUrl,
      timeout: 30000, // request timeout
      method: 'post',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      //{loaded, total, progress, bytes, estimated, rate, upload = true}
      /*onUploadProgress(progressEvent) {
        // Do whatever you want with the Axios progress event
        let persent = (progressEvent.loaded / progressEvent.total * 100 | 0)		//上传进度百分比
        callback(persent);
      },*/
    }).then((res) => {
      console.log(res);
      resolve(res);
    }).catch((error) => {
      if(error.message == "Network Error"){
        Message({
          showClose: true,
          message: 'Network Error',
          type: 'warning'
        });
      }
      reject(error);
    })
  })
  return promise;
};
